export interface Bonus {
  id: string
  title: string
  subtitle: string
  intro: string
  bullets: string[]
  closing: string
}

export const bonuses: Bonus[] = [
  {
    id: '01',
    title: '100 Judo Coaching Cues & Error Corrections',
    subtitle: 'See the mistake. Understand the cause. Give the right correction.',
    intro:
      'A practical visual coaching reference to help you identify common technical mistakes and correct them more clearly.',
    bullets: [
      'Posture, movement and grip corrections',
      'Kuzushi, Tsukuri and Kake corrections',
      'Ashi-waza and hip-throw error correction',
      'Seoi-waza correction',
      'Timing and combination errors',
      'Newaza and Randori corrections',
    ],
    closing: 'Stop repeating “try again” and start giving clearer technical feedback.',
  },
  {
    id: '02',
    title: 'Judo Athlete Development Roadmap',
    subtitle: 'Know what to teach now — and what should come next',
    intro:
      'A structured pathway for developing athletes from fundamental movement and safety toward more functional Judo.',
    bullets: [
      'Beginner development stages',
      'Technical readiness indicators',
      'Progress / regress decisions',
      'Core skill sequencing',
      'Moving technique and progression checkpoints',
      'Development planning across levels',
    ],
    closing:
      'Stop thinking only about today’s session. Start building the next stage of the judoka.',
  },
  {
    id: '03',
    title: 'Judo Coaching Methods & Teaching Psychology',
    subtitle: 'Teach more clearly. Communicate better. Help athletes learn faster.',
    intro: 'A guide focused on how to coach Judo effectively, not just what technique to demonstrate.',
    bullets: [
      'Better demonstrations',
      'Shorter and clearer coaching cues',
      'Feedback systems',
      'One-error correction method',
      'Coaching beginners vs advanced athletes',
      'Youth, teen and adult teaching considerations',
      'Mixed-level class coaching',
      'Motivation and communication',
    ],
    closing:
      'Better coaching is not only about knowing more Judo. It is about communicating it better.',
  },
  {
    id: '04',
    title: 'Judo Safety, Ukemi & Injury Prevention Guide',
    subtitle: 'Create safer training habits and more controlled technical development',
    intro:
      'A practical safety guide for coaches who want to train responsibly while building better technical habits.',
    bullets: [
      'Dojo safety and partner matching',
      'Ukemi progression',
      'Safe throwing progression',
      'Controlled finishing',
      'Randori safety',
      'Fatigue and technical breakdown',
      'Youth safety considerations',
      'Pre-session and during-session safety checks',
    ],
    closing: 'Develop technique without sacrificing responsibility for Uke.',
  },
  {
    id: '05',
    title: 'Judo Competition Preparation & Coach’s Match-Day Guide',
    subtitle: 'Prepare with structure. Coach with clarity. Review with purpose.',
    intro:
      'A practical coaching guide for preparing athletes before competition and turning event performance into useful development feedback.',
    bullets: [
      'Competition preparation timelines',
      'Technical and tactical priorities',
      'Match-day warm-up structure',
      'Pre-match coaching',
      'Between-match communication',
      'Tactical scenario thinking',
      'Post-match review',
      'Competition evaluation sheets',
    ],
    closing: 'Competition should give you useful coaching information — not just a result.',
  },
]
